import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4l0 10","key":"svg-0"}],["path",{"d":"M12 4l4 4","key":"svg-1"}],["path",{"d":"M12 4l-4 4","key":"svg-2"}],["path",{"d":"M4 20l16 0","key":"svg-3"}]]

const IconArrowBarUp = createReactComponent('outline', 'arrow-bar-up', 'ArrowBarUp', __iconNode);

export default IconArrowBarUp;